// extracted by mini-css-extract-plugin
export default {"root":"AppCheckboxAll_root__0H2+T"};